import { ALERT } from '../../model/msg/equip';
import { handleApiError } from '../../../../utils/service';
import { isDefined, isFunction, not, notSingleEle, truthy, falsy, getObjForPagination, parseInt10, getChangedStats } from '../../../../utils/util';
import { getUserStats, getUserSlotsStatus, getUserEquips, getStatReflectEquips, getStatNoEquips, setOrgStats } from '../../utils/service';
import { getMyCharactersTpl } from './../../model/tpl/equip';
import { API_DOMAIN_DEFAULT } from '../../../../model/model';
import EquipModel from '../EquipModel';
import SingletonLoading from '../../utils/SingletonLoading';

class MyCharacterStats {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      wrap: null,
      data: null,
      model: null,
      global: window
    }, options);

    _.model = EquipModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.data = _.option.data;

    _.pageIndex = 1;

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('MyCharacterStats wrap must be single element.');

    _.setInstance();

    return _;
  }

  orgStat() {
    const _ = this;

  }

  setInstance() {
    const _ = this;

    _.setContentsByPage(_.pageIndex);

    $(_.wrap).on('click', '.items', function (evt) {
      evt.preventDefault();

      if (truthy(_.loading.isLoading)) return;

      _.loading.start();

      const serverId = $(this).attr('data-server-id'),
        serverName = $('.info .server', this).text(),
        classId = $(this).attr('data-class-id'),
        characterName = $('.info .name', this).text(),
        classImageUrl = $('.thumb img', this).attr('src'),
        level = parseInt10($('.info .level', this).text());

      // console.log('serverId, serverName, classId, characterName, classImageUrl, level :', serverId, serverName, classId, characterName, classImageUrl, level);

      (async function() {
        try {
          const stats = await getUserStats({
            apiDomain: _.option.apiDomain,
            searchApiDomain: _.option.searchApiDomain,
            serverId: serverId,
            characterName: characterName
          });
          console.log('selectStatLayer/MyCharacterStats.js getUserStats() stats :', stats);

          const expandSlots = await getUserSlotsStatus({
            apiDomain: _.option.apiDomain,
            searchApiDomain: _.option.searchApiDomain,
            serverId: serverId,
            characterName: characterName
          });
          console.log('selectStatLayer/MyCharacterStats.js getUserSlotsStatus() expandSlots :', expandSlots);

          const equipItems = await getUserEquips({
            apiDomain: _.option.apiDomain,
            searchApiDomain: _.option.searchApiDomain,
            serverId: serverId,
            characterName: characterName
          });
          console.log('selectStatLayer/MyCharacterStats.js getUserEquips() equipItems :', equipItems);

          const noEquipStats = await getStatNoEquips({
            apiDomain: _.option.apiDomain,
            searchApiDomain: _.option.searchApiDomain,
            sendData: {
              classId: classId,
              level: level,
              hp: stats.hp,
              mp: stats.mp,
              currentStat: stats.mainStat
            }
          });
          console.log('selectSataLayer/MycharacterStats.js > getStatNoEquips() noEquipStats :', noEquipStats);

          if (equipItems.length <= 0) {
            console.log('my character - no equips');

            _.loading.end();

            $(_).trigger({
              type: MyCharacterStats.SET_MY_CHARACTER_STAT,
              obj: {
                serverId: serverId,
                serverName: serverName,
                classId: classId,
                classImageUrl: classImageUrl,
                characterName: characterName,
                level: level,
                hp: noEquipStats.formattedSubStat.hp,
                mp: noEquipStats.formattedSubStat.mp,
                noEquipStats: null,
                stats: noEquipStats,
                expandSlots: expandSlots,
                equipItems: equipItems,
                // changedStats: null,
                isEditable: true
              }
            });

            console.log( '## selectStatLayer/MyCharacterStats.js > select setOrgStats(data)  ##', setOrgStats({data: stats}) );
            setOrgStats({data: stats}); // 201908 org stats data push


          } else {
            console.log('selectStatLayer/MyCharacterStats.js > getUserEquips() getStatReflectEquips my character - has equips');

            const statReflectEquips = await getStatReflectEquips({
              apiDomain: _.option.apiDomain,
              searchApiDomain: _.option.searchApiDomain,
              sendData: {
                classId: classId,
                level: level,
                hp: stats.hp,
                mp: stats.mp,
                currentStat: stats.mainStat, // {STR, DEX, ...}
                itemList: equipItems
              }
            });
            console.log('selectStatLayer/MyCharacterStats.js > statReflectEquips :', statReflectEquips);

            _.loading.end();

            $(_).trigger({
              type: MyCharacterStats.SET_MY_CHARACTER_STAT,
              obj: {
                serverId: serverId,
                serverName: serverName,
                classId: classId,
                classImageUrl: classImageUrl,
                characterName: characterName,
                level: level,
                hp: statReflectEquips.formattedSubStat.hp,
                mp: statReflectEquips.formattedSubStat.mp,
                noEquipStats: noEquipStats,
                stats: statReflectEquips,
                expandSlots: expandSlots,
                equipItems: equipItems,
                // changedStats: null,
                isEditable: true
              }
            });
          }


          console.log( '## selectStatLayer/MyCharacterStats.js > select setOrgStats(data)  ##', setOrgStats({data: stats}) );
          setOrgStats({data: stats}); // 201908 org stats data push



          // end of try
        } catch(error) {
          _.loading.end();

          if (falsy(handleApiError(error.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
        }



      }());
    });
  }

  setContentsByPage(pageIndex) {
    const _ = this,
      paginationObj = getObjForPagination(_.option.data.length, _.model.MY_CHARACTER_STAT_PER_PAGE_NUM, _.model.MY_CHARACTER_STAT_PAGE_BTN_NUM, pageIndex);

    _.setItems(paginationObj);

    _.pageIndex = paginationObj.pageIndex;
  }

  setItems(paginationObj) {
    const _ = this;

    const startIndex = _.model.MY_CHARACTER_STAT_PER_PAGE_NUM * (paginationObj.pageIndex - 1),
      endIndex = _.model.MY_CHARACTER_STAT_PER_PAGE_NUM * paginationObj.pageIndex,
      items = _.data.slice(startIndex, endIndex);

    const tplFunc = doT.template(getMyCharactersTpl()),
      tpl = $(tplFunc(items));

    _.wrap.empty().append(tpl);

    _.setPagination(paginationObj);
    _.setPaginationBtnsEventHandler(true);
  }

  setPagination(paginationObj) { // totalItemsLength, listNumPerPage, displayPaginationBtnLength, pageIndex) {
    const _ = this;

    let tpl = '';
    if (paginationObj.prevPageIndex > 0) {
      tpl += `<button class="btn prev" data-paging="${paginationObj.prevPageIndex}">이전</button>`;

    } else {
      tpl += `<button class="btn prev" disabled="disabled">이전</button>`;
    }

    for (let i = paginationObj.firstPageIndex, max = paginationObj.lastPageIndex; i <= max; i++) {
      if (i === paginationObj.pageIndex) {
        tpl += `<span class="page selected">${i}</span>`;

      } else {
        tpl += `<span class="page" data-paging="${i}">${i}</span>`;
      }
    }

    if (paginationObj.nextPageIndex > 0) {
      tpl += `<button class="btn next" data-paging="${paginationObj.nextPageIndex}">다음</button>`;

    } else {
      tpl += `<button class="btn next" disabled="disabled">다음</button>`;
    }

    $('.pagination', _.wrap).append(tpl);
  }

  setPaginationBtnsEventHandler(flag) {
    const _ = this;

    if (truthy(flag)) {
      $('.pagination .btn.prev', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        _.setContentsByPage(parseInt10($(this).attr('data-paging')));
      });

      $('.pagination span.page', _.wrap).not('.selected').on('click', function (evt) {
        evt.preventDefault();
        _.setContentsByPage(parseInt10($(this).attr('data-paging')));
      });

      $('.pagination .btn.next', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        _.setContentsByPage(parseInt10($(this).attr('data-paging')));
      });

    } else {
      $('.pagination .btn.prev', _.wrap).off('click');
      $('.pagination span.page', _.wrap).off('click');
      $('.pagination .btn.next', _.wrap).off('click');
    }
  }

  show(flag) {
    (truthy(flag)) ? this.wrap.show() : this.wrap.hide();
  }

  destroy(obj = null) {
    const _ = this;

    $(_.wrap).off('click', '.items');

    _.setPaginationBtnsEventHandler(false);
  }
}

MyCharacterStats.SET_MY_CHARACTER_STAT = 'SET_MY_CHARACTER_STAT';

export default MyCharacterStats;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/selectStatLayer/MyCharacterStats.js